import { z } from "zod";

/**
 * One row of `GET list/assigned-to-campaigns/:listId` — the per-campaign assignment summary the
 * campaign builder falls back to when the derived status map is absent.
 *
 * The two flags are deliberately not interchangeable:
 * - `hasActiveProspects` — a step was processed **or** failed; the campaign actually started.
 * - `hasProcessedStep`   — a step was processed, i.e. something was really sent. This is what the
 *   builder's structural lock follows (PREC-3853): assigning leads leaves the sequence editable,
 *   and a schedule that only ever failed contacted nobody.
 */
export const assignedCampaignRowSchema = z.object({
	count: z.coerce.number(),
	campaignId: z.string(),
	hasActiveProspects: z.boolean(),
	hasProcessedStep: z.boolean(),
});

export type AssignedCampaignRow = z.infer<typeof assignedCampaignRowSchema>;

export const assignedCampaignsResponseSchema = z.object({
	data: z.array(assignedCampaignRowSchema),
});

export type AssignedCampaignsResponse = z.infer<typeof assignedCampaignsResponseSchema>;
